import { CalendarClockIcon } from '@components/icons/CalendarClockIcon';
import { alpha, styled } from '@mui/system';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';
interface ExpirationChipProps {
  expirationDate: string;
}
export const ExpirationChip = (props: ExpirationChipProps) => {
  const { expirationDate } = props;
  const expirationDateFormatted = format(
    parse(`${expirationDate}-01`, 'yyyy-MM-dd', new Date()),
    'MMM/yyyy',
    { locale: es },
  );
  const expirationDateTransformed =
    expirationDateFormatted.charAt(0).toUpperCase() +
    expirationDateFormatted.slice(1);

  return (
    <ExpirationChipContainer>
      <CalendarClockIcon />
      <span> Vence {expirationDateTransformed}</span>
    </ExpirationChipContainer>
  );
};

export const ExpirationChipContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  borderRadius: '20px',
  color: '#5D5FEF',
  maxWidth: '142px',
  backgroundColor: alpha('#7879F1', 0.12),
  margin: '5px 0px',
  padding: '0px 8px 0px 3px',
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '100%',
  letterSpacing: '0.15px',
});
